import React from 'react';

export default () => (
  <svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 7.5V17.75C21 19.5449 19.5449 21 17.75 21H6.25C4.45507 21 3 19.5449 3 17.75V7.5L12 6.5L21 7.5Z"
      fill="url(#paint0_linear_1070_13131)"
    />
    <path
      d="M21 7.5V17.75C21 19.5449 19.5449 21 17.75 21H6.25C4.45507 21 3 19.5449 3 17.75V7.5L12 6.5L21 7.5Z"
      fill="url(#paint1_linear_1070_13131)"
    />
    <path
      d="M21 7.5V17.75C21 19.5449 19.5449 21 17.75 21H6.25C4.45507 21 3 19.5449 3 17.75V7.5L12 6.5L21 7.5Z"
      fill="url(#paint2_radial_1070_13131)"
      fill-opacity="0.3"
    />
    <path
      d="M17.75 3C19.5449 3 21 4.45507 21 6.25V8H3V6.25C3 4.45507 4.45507 3 6.25 3H17.75Z"
      fill="url(#paint3_linear_1070_13131)"
    />
    <path
      d="M17.5 12C20.5376 12 23 14.4624 23 17.5C23 20.5376 20.5376 23 17.5 23C14.4624 23 12 20.5376 12 17.5C12 14.4624 14.4624 12 17.5 12Z"
      fill="url(#paint4_linear_1070_13131)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.5 14C17.7761 14 18 14.2239 18 14.5V17H20C20.2761 17 20.5 17.2239 20.5 17.5C20.5 17.7761 20.2761 18 20 18H17.5C17.2239 18 17 17.7761 17 17.5V14.5C17 14.2239 17.2239 14 17.5 14Z"
      fill="url(#paint5_linear_1070_13131)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1070_13131"
        x1="9.42857"
        y1="6.5"
        x2="14.1366"
        y2="20.9321"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B3E0FF" />
        <stop offset="1" stop-color="#8CD0FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1070_13131"
        x1="13.9286"
        y1="12.4318"
        x2="16.625"
        y2="24.267"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DCF8FF" stop-opacity="0" />
        <stop offset="1" stop-color="#FF6CE8" stop-opacity="0.7" />
      </linearGradient>
      <radialGradient
        id="paint2_radial_1070_13131"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.7857 19.0227) rotate(90) scale(8.56818 8.35714)"
      >
        <stop offset="0.535" stop-color="#4A43CB" />
        <stop offset="1" stop-color="#4A43CB" stop-opacity="0" />
      </radialGradient>
      <linearGradient
        id="paint3_linear_1070_13131"
        x1="3.72321"
        y1="3"
        x2="5.35631"
        y2="11.5369"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0094F0" />
        <stop offset="1" stop-color="#2764E7" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1070_13131"
        x1="13.8333"
        y1="11.3889"
        x2="19.3333"
        y2="23.6111"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1EC8B0" />
        <stop offset="1" stop-color="#2764E7" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1070_13131"
        x1="17.3063"
        y1="14.6122"
        x2="16.3983"
        y2="17.8798"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFDFD" />
        <stop offset="1" stop-color="#D1D1FF" />
      </linearGradient>
    </defs>
  </svg>
);
